module.exports = __webpack_public_path__ + "left.svg?4452da8a90138d9261743021df31cce4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.svg
// module id = 85
// module chunks = 0